import React, { useEffect, useState } from "react";
import { NavLink as ReactLink, useNavigate } from "react-router-dom";
import { Navbar, NavbarBrand, Nav, NavItem } from "react-bootstrap";
import { doLogout, getUser, isLoggedIn } from "../services/user-service";
import "../css/AdminNavbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";

const AdminNavbar = () => {
  const navigate = useNavigate();
  const user = getUser();

  const [imageSrc, setImageSrc] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);

  const togglePopup = () => setPopupOpen(!isPopupOpen);

  const base64ToImage = () => {
    const base64String = user.image;
    const trimmedBase64 = base64String ? base64String.trim() : "";
    if (trimmedBase64) {
      setImageSrc(`data:image/jpeg;base64,${trimmedBase64}`);
    }
  };

  useEffect(() => {
    base64ToImage();
  }, []);

  const logout = () => {
    doLogout();
    navigate("/");
  };

  return (
    <div>
      <Navbar className="navbar" expand="lg">
        <NavbarBrand style={{ paddingLeft: "20px" }}>
          <ReactLink to="/admin/dashboard">
            <img className="navbar_logo_image" src="/logo192.png" alt="logo" />
          </ReactLink>
        </NavbarBrand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ marginRight: "20px" }} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={ReactLink} to="/admin/dashboard" className="navname">Dashboard</Nav.Link>
            <Nav.Link className="navname" onClick={() => alert("Coming soon")}>Reports</Nav.Link>
            <Nav.Link as={ReactLink} to="/admin/employees" className="navname">Employees</Nav.Link>
          </Nav>
          <Nav navbar>
            <NavItem>
              <div onClick={togglePopup} className="nav-user-name navbar_link">
                <img src={imageSrc || "./../../../img/avtar.jpg"} alt="avatar" />
                {user.firstName + " " + user.lastName}
                <FontAwesomeIcon icon={faCaretDown} style={{ marginLeft: "10px" }} />
              </div>
            </NavItem>
            {isPopupOpen && (
              <div className="popup1">
                <ul>
                  {/* <ReactLink to="/admin/profile" className="navbar_link">Profile</ReactLink> */}
                  <ReactLink to="/admin/dashboard" className="navbar_link">Dashboard</ReactLink>
                  <a onClick={logout} className="navbar_link">Logout</a>
                </ul>
              </div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default AdminNavbar;
